import * as React from 'react';

const DiscountBar = ({ title  })=>/*#__PURE__*/ React.createElement("div", {
        className: "discount-bar"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "discount-bar__title"
    }, title))
;

export { DiscountBar as default };
//# sourceMappingURL=DiscountBar.js.map
